import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Podcast = createReactComponent("Podcast", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "11",
  r: "1",
  key: "6ljrkr"
}], ["path", {
  d: "M17.03 18.46a9 9 0 10-10.02.03",
  key: "103srb"
}], ["path", {
  d: "M16.06 13.91a5 5 0 10-7.97.2",
  key: "12jfsu"
}], ["path", {
  d: "M11.11 17a.9.9 0 111.78 0l-.52 4.67a.37.37 0 01-.74 0l-.52-4.68z",
  key: "1ggobr"
}]]]);
export default Podcast;